import React, {useState} from "react";

import './view2.scss'
import MeterIcon from './icons/meter.svg'
import FireIcon from './icons/fire.svg'
import HeadsetIcon from './icons/headset.svg'
import PizzaIcon from './icons/pizza.svg'
import TargetIcon from './icons/target.svg'

const View2 = (props) => {
    const {handleScroll} = props;
    const items = [
        {
            id: 1,
            title: 'وعده های غذایی در دسترس بدون حذف هیچ گروه غذایی',
            icon: PizzaIcon,
        },
        {
            id: 2,
            title: 'چنگال بهترین انتخابه',
            icon: null,
            type: 'slogan'
        },
        {
            id: 3,
            title: 'تنظیم سوخت و ساز بدن برای چربی سوزی بیشتر',
            icon: FireIcon,
        },
        {
            id: 4,
            title: 'امکان هدف‌گذاری برای رسیدن به وزن دلخواه',
            icon: TargetIcon,
        },
        {
            id: 5,
            title: 'تناسب وزن ماندگار با ایجاد عادت های غذایی سالم',
            icon: MeterIcon,
        },
        {
            id: 6,
            title: 'پشتیبانی اختصاصی و نامحدود برای کاربران',
            icon: HeadsetIcon,
        },
    ]

    const getCard = (item) => {
        return <div className={item.type === 'slogan' ? 'item-slogan' : 'item-card'}>
            {item.icon ? <div className='item-icon'><img src={item.icon}/></div> : null}
            {item.title ? <div className='item-title'>{item.title}</div> : null}
        </div>;
    }

    return (<>
        <div className={'box-cover-view-2'} onScroll={()=>handleScroll(true)}>
        <div className={`view2-container `}>

                <div className={'box '}>
                    <div className='row'>
                        {items.filter(item => [1, 2, 3].includes(item.id)).map(item => {
                            return getCard(item);
                        })}
                    </div>
                    <div className='row mt'>
                        {items.filter(item => [4, 5, 6].includes(item.id)).map(item => {
                            return getCard(item);
                        })}
                    </div>
                </div>
            </div>
        </div>
    </>)
}
export default View2;
